import { Validators } from '@angular/forms';

export const password = Validators.pattern('(?=.*?[A-Z]?)(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]?).{8,}');
